import Page from './politica-de-privacidade'
export default Page
